import SummaryCards from "./components/SummaryCards";
import AutomationCard from "./components/AutomationCard";
import TodayTasks from "./components/TodayTasks";
import CampaignProgress from "./components/CampaignProgress";
import ActivityFeed from "./components/ActivityFeed";
import MiniCharts from "./components/MiniCharts";

export default function DashboardPage() {
  return (
    <div className="p-4 md:p-6 xl:p-8 space-y-6 max-w-[1600px]">
      {/* Page header */}
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h2 className="text-xl font-bold text-gray-900">Genel Bakış</h2>
          <p className="text-sm text-gray-500 mt-0.5">Hoş geldiniz! Bugünün durumu aşağıda özetlenmiştir.</p>
        </div>
        <div className="flex items-center gap-3 flex-wrap">
          <button className="px-4 py-2 text-sm border border-gray-200 rounded-xl text-gray-600 hover:bg-gray-50 cursor-pointer transition-colors whitespace-nowrap flex items-center gap-2">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-refresh-line text-sm"></i>
            </div>
            Yenile
          </button>
          <button className="px-4 py-2 text-sm bg-[#0B1120] text-white rounded-xl hover:bg-[#1a2a4a] cursor-pointer transition-colors whitespace-nowrap flex items-center gap-2">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-send-plane-line text-sm"></i>
            </div>
            Kampanya Başlat
          </button>
        </div>
      </div>

      {/* Summary cards */}
      <SummaryCards />

      {/* Automation status */}
      <AutomationCard />

      {/* Middle row */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <TodayTasks />
        </div>
        <div>
          <CampaignProgress />
        </div>
      </div>

      {/* Charts */}
      <MiniCharts />

      {/* Activity feed */}
      <ActivityFeed />
    </div>
  );
}